import {Component, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";

@Component({
    selector: 'app-new-exam',
    templateUrl: './new-exam.component.html',
    styleUrls: ['./new-exam.component.scss'],
})
export class NewExamComponent implements OnInit {

    constructor(private modalCtrl: ModalController) {
    }


    ngOnInit() {

        console.log('new exam')
    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }


    goToTestsPage(){
        return this.modalCtrl.dismiss(null, 'goToTestPage');
    }

}
